const ENIntegrationTypes = {
	"Adicionar tipo de integração": "Add integration type",
	"Adicionar variável": "Add variable",
	"Alterar tipo de integração": "Change integration type",
	"Deseja realmente excluir o tipo de integração": "Do you really want to delete the integration type",
	"Endereço": "Address",
	"Erro ao adicionar tipo de integração": "Error on adding integration type",
	"Erro ao alterar tipo de integração": "Error on changing integration type",
	"Erro ao excluir tipo de integração": "Error on deleting integration type",
	"Exclusão de tipo de integração": "Delete integration type",
	"Nenhuma Variável encontrada": "No variable found",
	"Nome do serviço": "Service name",
	"Novo tipo de integração": "New integration type",
	"Porta": "Port",
	"Protocolo": "Protocol",
	"Tipo de integração adicionada com sucesso": "Integration type successfully added",
	"Tipo de integração alterada com sucesso": "Integration type successfully changed",
	"Tipo de integração excluído com sucesso": "Integration type successfully deleted",
	"Tipo de integração": "Integration type",
	"Tipos de Integração": "Integration types",
	"Variáveis": "Variables"
};

export default ENIntegrationTypes;
